import React from 'react';
import { Flame, Instagram, MapPin, Phone } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { Logo } from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openChatbot = () => {
    window.dispatchEvent(new CustomEvent('open-chatbot', { detail: { context: '' } }));
  };

  return (
    <footer className="bg-stone-950 border-t border-stone-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-4">
              <Logo variant="horizontal" size="md" />
            </div>
            <p className="text-stone-400 mb-6 max-w-md">
              Somos uma empresa pra lá de bagual! Fabricamos churrasqueiras rotativas de alta qualidade para o verdadeiro churrasco gaúcho. Tradição e durabilidade em cada produto.
            </p>
            <div className="flex items-center gap-4">
              <a
                href={companyInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-stone-800 hover:bg-pink-600/20 rounded-lg flex items-center justify-center transition-colors group"
              >
                <Instagram className="w-5 h-5 text-stone-400 group-hover:text-pink-500 transition-colors" />
              </a>
              <button
                type="button"
                onClick={openChatbot}
                aria-label="Falar com o atendente"
                className="w-10 h-10 bg-stone-800 hover:bg-green-600/20 rounded-lg flex items-center justify-center transition-colors group"
              >
                <Phone className="w-5 h-5 text-stone-400 group-hover:text-green-500 transition-colors" />
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Links Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('hero')} className="text-stone-400 hover:text-amber-500 transition-colors">
                  Início
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('products')} className="text-stone-400 hover:text-amber-500 transition-colors">
                  Produtos
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('benefits')} className="text-stone-400 hover:text-amber-500 transition-colors">
                  Benefícios
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-stone-400 hover:text-amber-500 transition-colors">
                  Contato
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contato</h4>
            <ul className="space-y-3">
              <li>
                <button
                  type="button"
                  onClick={openChatbot}
                  className="flex items-start gap-2 text-stone-400 hover:text-green-400 transition-colors text-left"
                >
                  <Phone className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                  <span>Falar com atendente</span>
                </button>
              </li>
              <li className="flex items-start gap-2 text-stone-400">
                <MapPin className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                <span>{companyInfo.fullAddress}</span>
              </li>
              <li>
                <a
                  href={companyInfo.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-2 text-stone-400 hover:text-pink-400 transition-colors"
                >
                  <Instagram className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" />
                  <span>@rotativagaucha</span>
                </a>
              </li>
              <li className="text-stone-500 text-sm pt-2">
                Seg - Sex: 8h às 18h
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-stone-800 space-y-4">
          {/* Fabricante / Empresa */}
          <div className="bg-stone-900/60 border border-stone-800 rounded-lg p-4">
            <p className="text-amber-500 text-xs font-semibold uppercase tracking-wide mb-1">Fabricado por</p>
            <p className="text-stone-200 text-sm font-semibold">AGRIMEQ MONTAGENS MANUT AGROINDUSTRIAIS LTDA</p>
            <p className="text-stone-400 text-xs mt-1">
              Rua Emílio Villani, 855 — Área Industrial, Industrial — Pejuçara/RS — CEP 98270-000
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-stone-500 text-sm text-center md:text-left">
              © {currentYear} Rotativa Gaúcha. Todos os direitos reservados.
            </p>
            <p className="text-stone-600 text-sm flex items-center gap-1">
              Feito com <Flame className="w-4 h-4 text-amber-500" /> no Rio Grande do Sul
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
